module.exports = __webpack_public_path__ + "static/media/diana_ferguson.0dd1efdf.jpg";